module.exports = __webpack_public_path__ + "img/mastercard.6b4d3786.png";